import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    MedicalRecordVisitReasonConverter
} from "../../../../../../../modules/medical/medical-record/visit-reason/api/converter/medicalRecordVisitReason.converter";
import {
    MedicalRecordVisitReasonModel
} from "../../../../../../../modules/medical/medical-record/visit-reason/api/model/medicalRecordVisitReason.model";
import {ConsultationVisitReasonItemComponent} from "../consultation-visit-reason-item/consultation-visit-reason-item.component";

@Component({
    selector: 'app-visit-reason-ai-event',
    standalone: true,
    imports: [ConsultationVisitReasonItemComponent],
    template: `
    <app-luna-consultation-visit-reason-item
      titleDisplay="title"
      [visitReason]="visitReason">
    </app-luna-consultation-visit-reason-item>
  `,
})
export class ConsultationVisitReasonAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'medicalVisitReason';
    visitReason: MedicalRecordVisitReasonModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private visitReasonConverter: MedicalRecordVisitReasonConverter) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.visitReason = this.visitReasonConverter.convert(this.event?.data);
    }
}
